'use strict';

exports.__esModule = true;

var _wavEncoder = require('./wav-encoder');

var _wavEncoder2 = _interopRequireDefault(_wavEncoder);

var _utils = require('./utils');

function _interopRequireDefault (obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}

var _class = (function () {
    function _class () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, _class);

        this.afterStop = options.afterStop;
        this.micFailed = options.micFailed;

        this.bufferSize = 4096;
        this.records = [];
        this.samples = [];

        this.isPause = false;
        this.isRecording = false;

        this.duration = 0;
        this.volume = 0;
        this.timerDur = 0;

        this._duration = 0;
        this.my_media;
    }

    _class.prototype.start = function start () {
        if (pgap) {
            window.cool = this;
            console.log(this);
            console.log('recording sample: ', this.records.length);
            this.my_media = new Media(
                device.platform === 'Android'
                    ? `${cordova.file.dataDirectory}recording-${this.records.length}.aac`
                    : `documents://recording-${this.records.length}.wav`,
                e => {
                    console.log('recordAudio():Audio Success', e);
                },
                // error callback
                err => {
                    console.log('recordAudio():Audio Error: ' + err.code);
                }
            );

            this.my_media.startRecord();
            this.timerDur = setInterval(() => {
                this.duration++;
            }, 1000);
        } else {
            navigator.mediaDevices
                .getUserMedia({ audio: true })
                .then(this._micCaptured.bind(this))
                .catch(this._micError.bind(this));
        }
        this.isPause = false;
        this.isRecording = true;
    };

    _class.prototype.stop = function stop () {
        if (pgap) {
            this.my_media.stopRecord();
            clearInterval(this.timerDur);
            this.my_media.play();
            setTimeout(() => {
                this.my_media.stop();
                setTimeout(() => {
                    this.duration = this.my_media.getDuration();
                    console.log(this.duration);
                }, 10);
                //console.log(this.my_media.src);
                //console.log(this.my_media.src.replace('documents://', cordova.file.documentsDirectory));
                //var url = this.my_media.src.replace('documents://', cordova.file.documentsDirectory);
                this.records.push({
                    id: Date.now(),
                    //blob: audioBlob,
                    duration: (0, _utils.convertTimeMMSS)(this.duration),
                    url: this.my_media.src
                    // .replace('documents://', cordova.file.documentsDirectory)
                });
            }, 300);
        } else {
            this.stream.getTracks().forEach(function (track) {
                return track.stop();
            });

            this.input.disconnect();
            this.processor.disconnect();
            this.context.close();

            var encoder = new _wavEncoder2.default({
                bufferSize: this.bufferSize,
                sampleRate: this.context.sampleRate,
                samples: this.samples
            });

            var audioBlob = encoder.getData();
            var audioUrl = URL.createObjectURL(audioBlob);

            this.samples = [];

            this.records.push({
                id: Date.now(),
                blob: audioBlob,
                duration: (0, _utils.convertTimeMMSS)(this.duration),
                url: audioUrl
            });
        }

        setTimeout(() => {
            this._duration = 0;
            this.duration = 0;

            this.isPause = false;
            this.isRecording = false;

            if (this.afterStop) {
                this.afterStop();
            }
        }, pgap ? 400 : 1);
    };

    _class.prototype.pause = function pause () {
        this.stream.getTracks().forEach(function (track) {
            return track.stop();
        });
        this.input.disconnect();
        this.processor.disconnect();
        this.context.close();

        this._duration = this.duration;
        this.isPause = true;
    };

    _class.prototype.recordList = function recordList () {
        return this.records;
    };

    _class.prototype.lastRecord = function lastRecord () {
        return this.records.slice(-1);
    };

    _class.prototype._micCaptured = function _micCaptured (stream) {
        var _this = this;

        this.context = new (window.AudioContext || window.webkitAudioContext)();
        this.duration = this._duration;
        this.input = this.context.createMediaStreamSource(stream);
        this.processor = this.context.createScriptProcessor(this.bufferSize, 1, 1);
        this.stream = stream;

        this.processor.onaudioprocess = function (ev) {
            var sample = ev.inputBuffer.getChannelData(0);
            var sum = 0.0;

            for (var i = 0; i < sample.length; ++i) {
                sum += sample[i] * sample[i];
            }

            _this.duration = parseFloat(_this._duration) + parseFloat(_this.context.currentTime.toFixed(2));
            _this.volume = Math.sqrt(sum / sample.length).toFixed(2);
            _this.samples.push(new Float32Array(sample));
        };

        this.input.connect(this.processor);
        this.processor.connect(this.context.destination);
    };

    _class.prototype._micError = function _micError (error) {
        if (this.micFailed) {
            this.micFailed(error);
        }
    };

    return _class;
})();

exports.default = _class;
